import React from 'react';
import styled from 'styled-components';

const Badge = styled.span`
  ${({ theme }) => theme.typographyRebrand.body.xs}
  font-weight: var(--typography-font-weight-bold);
  background-color: ${(p) => p.theme.c.tag.bg.primary};
  padding: ${({ theme }) => theme.unit(0.25)} ${({ theme }) => theme.unit(1)};
  border-radius: ${({ theme }) => theme.radius.xl};
  color: ${(p) => p.theme.c.tag.text.primary};
`;

const AccesibilityBadge = styled.span`
  display: none;
`;

const PromoBadge = ({ extraMilesText, pluralFlatRateMilesText, className }) => {
  return (
    <div>
      <AccesibilityBadge>
        {extraMilesText} {pluralFlatRateMilesText}
      </AccesibilityBadge>
      <Badge className={className}>
        {extraMilesText} {pluralFlatRateMilesText}
      </Badge>
    </div>
  );
};

export default PromoBadge;
